export const TmetricSettingsMutations = {
  setTmetricSettingsValue: (state, value) => { state.tmetricSettings.value = value },
  setTmetricAPIKeyValid: (state, value) => { state.tmetricAPIKeyValid = value },
  setTmetricEnableDetails: (state, value) => { state.tmetricEnableDetails = value },
  setTmetricExpirationDate: (state, date) => { state.tmetricSettings.tmetric_expires_at = date },
  setTmetricSettings: (state, data) => { state.tmetricSettings = data },
  setTmetricSettingsLoading: (state, value) => { state.tmetricSettingsLoading = value },
  setTmetricWorkspaceName: (state, value) => { state.tmetricWorkspaceName = value },
  setTmetricWorkspaces: (state, workspaces) => { state.tmetricWorkspaces = workspaces },
}
